import React, { memo } from "react";
import { Check, ChevronRight, Share, UserPlus, Spade, X } from "lucide-react";
import "./group-setup.css";

// "Get your group ready" on Home, for the group's moderator until the group
// has played a game (or the card is closed). Each step says what it's for, so
// a first-time host knows the difference between players and members.
export const GroupSetupCard = memo(function GroupSetupCard({ groupName, playerCount, memberCount, gameCount, onAddPlayers, onInvite, onStartGame, onDismiss }) {
  const steps = [
    {
      key: "players",
      icon: UserPlus,
      title: "Add your players",
      body: "Everyone who sits at your table, even friends without the app. Players are what buy-ins and results are recorded against.",
      done: playerCount >= 2,
      status: playerCount ? `${playerCount} ${playerCount === 1 ? "player" : "players"}` : "",
      onClick: onAddPlayers,
    },
    {
      key: "invite",
      icon: Share,
      title: "Invite your friends",
      body: "Share the invite link. Friends who join can follow games and see their own stats, and get linked to their player.",
      done: memberCount >= 2,
      status: memberCount >= 2 ? `${memberCount - 1} joined` : "",
      onClick: onInvite,
    },
    {
      key: "game",
      icon: Spade,
      title: "Start your first game",
      body: "Pick who's playing and the buy-in, then tap players to add rebuys as the night goes.",
      done: gameCount > 0,
      status: "",
      onClick: onStartGame,
    },
  ];
  const doneCount = steps.filter((s) => s.done).length;

  return (
    <section className="setup-card" aria-labelledby="setup-card-title">
      <header className="setup-card-head">
        <div className="setup-card-heading">
          <h2 id="setup-card-title" className="setup-card-title">Get {groupName || "your group"} ready</h2>
          <p className="setup-card-progress">{doneCount} of {steps.length} done</p>
        </div>
        <button type="button" className="setup-card-close" aria-label="Hide setup steps" onClick={onDismiss}>
          <X size={18} />
        </button>
      </header>
      <ol className="setup-steps">
        {steps.map((step, i) => {
          const Icon = step.icon;
          return (
            <li key={step.key}>
              <button type="button" className={`setup-step${step.done ? " setup-step--done" : ""}`} onClick={step.onClick}>
                <span className="setup-step-mark" aria-hidden="true">
                  {step.done ? <Check size={16} strokeWidth={3} /> : <Icon size={16} />}
                </span>
                <span className="setup-step-text">
                  <span className="setup-step-title-row">
                    <span className="setup-step-title">
                      <span className="sr-only">Step {i + 1}{step.done ? ", done" : ""}: </span>
                      {step.title}
                    </span>
                    {step.status && <span className="setup-step-status">{step.status}</span>}
                  </span>
                  <span className="setup-step-body">{step.body}</span>
                </span>
                <ChevronRight size={18} className="setup-step-chevron" aria-hidden="true" />
              </button>
            </li>
          );
        })}
      </ol>
    </section>
  );
});
